import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/display.actions';

import Dialog from '@material-ui/core/Dialog';
import Snackbar from '../../../labels/Snackbar';

class Callback extends React.Component {
    state = {
        error: undefined,
        done: false,
    };

    UNSAFE_componentWillMount() {
        const parameters = this.props.location.search.split('&');
        const code = parameters['0'].replace('?code=', '');
        const state = parameters['1'].replace('state=', '');
        this.props
            .callback(code, state)
            .then(() => {
                this.setState({ done: true });
            })
            .catch((error) => {
                this.setState({ error: error.message });
            });
    }

    handleClose = () => {
        this.props.history.push('/manage/displays');
    };

    render() {
        const { error, done } = this.state;
        return (
            <Dialog
                fullScreen={false}
                open={true}
                onClose={this.handleClose}
                className={'z_index_dialog '}
                classes={{ paper: !error && !done ? 'opacity' : '' }}
            >
                {!error && !done && (
                    <div className={'bg_ice_blue padding_borders_equals loading_image'}>
                    </div>
                )}
                {error && (
                    <Snackbar open={true} variant="error" text={error} onClose={this.handleClose} />
                )}
                {done && (
                    <Snackbar
                        open={true}
                        variant="info"
                        message={'operation_done_correctly'}
                        onClose={this.handleClose}
                    />
                )}
            </Dialog>
        );
    }
}

Callback.propTypes = {
    intl: intlShape.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    null,
    mapDispatchToProps,
)(injectIntl(withRouter(Callback)));



// WEBPACK FOOTER //
// ./src/components/complex/manage/displayscallback/Index.js